import { ringDashboardURL, ringMobileDashboardURL } from '$src/constants/urls';
import getEnvironment from '$src/utils/enviroment';
import isWebView from '$src/utils/user-agent';
import { redirectToURL } from '$src/utils/redirect';

export function getRingDashboardUrl(isMobile) {
  let dashboardUrl;
  if (isWebView() && isMobile) {
    dashboardUrl = ringMobileDashboardURL;
  } else {
    dashboardUrl = ringDashboardURL[getEnvironment()];
  }
  return dashboardUrl;
}

export function handleBackToRingDashboard(isMobile) {
  const dashboardUrl = getRingDashboardUrl(isMobile);
  redirectToURL(dashboardUrl);
}
